import styled from 'styled-components';

import Text from 'components/_core/Text';

export const PaymentCardImg = styled.img`
  height: 166px;
  width: 263px;
  border-radius: 10px;
  box-shadow:
    0px 5px 20px rgba(0, 0, 0, 0.08),
    0px 1px 3px rgba(0, 0, 0, 0.08);
`;

export const PaymentCardWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacings.abs40}px;
`;

export const VatMentionText = styled(Text).attrs({
  size: 'sm',
  variant: 'light',
})`
  display: block;
  margin-top: ${({ theme }) => theme.spacings.abs16}px;
  padding-left: ${({ theme }) => theme.spacings.abs16}px;
`;

export const InfoBoxWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacings.abs32}px;
`;

export const ErrorBoxWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacings.abs24}px;
`;
